<div class="root">
  <top-header
    [systemWorkingIndicatorStatus]="systemWorkingIndicatorStatus"
    (openChannelPreview)="channelPreview.show($event)"
  ></top-header>

  <router-outlet></router-outlet>
  <!-- Alert Component -->
  <alert [alertObject]="alert" [active]="alert.display"></alert>

  <video-preview></video-preview>

  <icn-channel-preview></icn-channel-preview>
  <gaps-report [hidden]="!showGapReport"></gaps-report>
  <missing-sub-titles-report
    [hidden]="!showMissingSubtitlesReport"
  ></missing-sub-titles-report>
  <missing-audios-report
    [hidden]="!showMissingAudiosReport"
  ></missing-audios-report>

  <evrideo-empty-contracts-report
    [hidden]="!showEmptyContractsReport"
  ></evrideo-empty-contracts-report>
  <div class="konami" [hidden]="!konami">
    <div class="frame">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <h1>Evrideo</h1>
    <canvas id="konami"></canvas>
  </div>
</div>
